import React from "react";
import NoTranslate from "./NoTranslate";

type Props = {
  firstName?: string | null;
  lastName?: string | null;
  name?: string | null;
  email?: string | null;
  avatar?: string | null;
  sizeClass?: string;
  textClass?: string;
  deleted?: boolean;
};

function computeInitials({
  firstName,
  lastName,
  name,
  email,
}: Pick<Props, "firstName" | "lastName" | "name" | "email">): string {
  if (firstName && lastName) {
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  }
  const display =
    name || [firstName, lastName].filter(Boolean).join(" ").trim();
  if (display) return display.charAt(0).toUpperCase();
  if (email) return email.charAt(0).toUpperCase();
  return "?";
}

const UserAvatar: React.FC<Props> = ({
  firstName,
  lastName,
  name,
  email,
  avatar,
  sizeClass = "w-8 h-8",
  textClass = "text-sm",
  deleted = false,
}) => {
  const alt =
    [firstName, lastName].filter(Boolean).join(" ") || name || email || "";

  if (avatar) {
    return (
      <img
        src={avatar}
        alt={alt}
        className={`${sizeClass} rounded-full object-cover border border-gray-200 shrink-0 ${
          deleted ? "grayscale opacity-60" : ""
        }`}
      />
    );
  }

  const initials = computeInitials({ firstName, lastName, name, email });
  return (
    <div
      className={`${sizeClass} ${textClass} rounded-full flex items-center justify-center font-medium shrink-0 ${
        deleted ? "bg-gray-200 text-gray-500" : "bg-gray-100 text-gray-600"
      }`}
    >
      <NoTranslate>{initials}</NoTranslate>
    </div>
  );
};

export default UserAvatar;
